import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { share, tap } from 'rxjs/operators';

import { HttpCacheService } from './http-cache.service';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(private httpCacheService: HttpCacheService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.method !== 'GET' || request.url.includes('/sso/')) {
      return next.handle(request);
    }

    const cachedValue = this.httpCacheService.getValue(request);

    if (cachedValue) {
      if (cachedValue instanceof Observable) {
        // Parallel request to same endpoint, return handler in process
        return cachedValue;
      } else {
        // Return cached value
        return of(cachedValue);
      }
    } else {
      const requestHandle = next.handle(request).pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            // Request processed, cache the response
            this.httpCacheService.setValue(request, event);
          }
        }),
        share()
      );

      // Request in process, cache the handle
      this.httpCacheService.setValue(request, requestHandle);

      return requestHandle;
    }
  }
}
